import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DataGrid, { Column, Scrolling } from 'devextreme-react/data-grid';
import { formatCurrency, formatDate } from '../../common/SharedFunctions';
import { FieldChangeDataType } from '@apply/constants';
import { formatDateTime } from '@apply/ui';

export const AuditDetailsDialog = ({ isOpen = false, auditEntry, onClose }) => {
    const styles = {
        buttonMarginRight: { marginRight: '10px' },
        buttonContainer: {
            textAlign: 'right',
            borderTop: '2px solid silver',
            padding: '10px 10px',
        },
        form: { paddingLeft: '5px', paddingTop: '10px' },
        formRow: { marginBottom: '0' },
    };

    const _onClose = async (e) => {
        e.preventDefault();
        e.stopPropagation();
        onClose && onClose();
    };

    const onCellRender = (e, isNewValue) => {
        let output = null;
        switch (e.data.dataTypeId) {
            case FieldChangeDataType.Percent:
                if (e.value) {
                    output = parseFloat(e.value).toFixed(2) + '%';
                } else {
                    output = e.value;
                }
            case FieldChangeDataType.Currency:
                if (e.value) {
                    const val = parseFloat(e.value);
                    output = formatCurrency(val);
                } else {
                    output = e.value;
                }
            case FieldChangeDataType.Boolean:
                output = e.value === 'True' ? 'Yes' : 'No';
            case FieldChangeDataType.Date:
                if (e.value) {
                    const dt = new Date(e.value);
                    output = formatDate(dt);
                } else {
                    output = e.value;
                }
            default:
                output = e.value;
        }

        if (isNewValue && e.data.reason) {
            return (
                <>
                    {output}
                    <br />
                    Reason: {e.data.reason}
                </>
            );
        }
        return output;
    };

    if (!isOpen || !auditEntry) {
        return null;
    }

    return (
        <>
            <Dialog
                maxWidth='sm'
                open={isOpen}
                onClose={_onClose}
                aria-labelledby='form-dialog-title'
            >
                <DialogContent>
                    <div className='modal-container'>
                        <div className='modal-backdrop'></div>
                        <div
                            className='modal'
                            tabIndex={-1}
                            role='dialog'
                            style={{ width: '1100px' }}
                        >
                            <div
                                className='modal-dialog'
                                role='document'
                            >
                                <div
                                    className='page-header'
                                    role='banner'
                                >
                                    <h1 style={{ whiteSpace: 'nowrap' }}>Audit History Details</h1>
                                    <button
                                        type='button'
                                        className='close'
                                        data-dismiss='modal'
                                        aria-label='Close'
                                        onClick={_onClose}
                                    >
                                        <span aria-hidden='true'>&times;</span>
                                    </button>
                                </div>
                            </div>
                            <div
                                className='scrollable-content'
                                style={{ padding: '10px' }}
                            >
                                <div
                                    style={styles.form}
                                    className={'standard-form'}
                                >
                                    <div
                                        className='row'
                                        style={styles.formRow}
                                    >
                                        <div className='columns small-12 large-12'>
                                            <table>
                                                <tbody>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                width: '140px',
                                                            }}
                                                        >
                                                            Timestamp:
                                                        </td>
                                                        <td>{formatDateTime(auditEntry.dateAndTime)}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>User:</td>
                                                        <td>{auditEntry.userName}</td>
                                                    </tr>
                                                    {auditEntry.reason && (
                                                        <tr>
                                                            <td>Reason:</td>
                                                            <td>{auditEntry.reason}</td>
                                                        </tr>
                                                    )}
                                                    {auditEntry.notes && (
                                                        <tr>
                                                            <td>Notes:</td>
                                                            <td>{auditEntry.notes}</td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div>
                                        <DataGrid
                                            dataSource={auditEntry.entries}
                                            showBorders={true}
                                            showRowLines={false}
                                            showColumnHeaders={true}
                                            rowAlternationEnabled={true}
                                            columnMinWidth={50}
                                            columnAutoWidth={false}
                                            allowSorting={true}
                                            allowColumnResizing={true}
                                            height={350}
                                        >
                                            <Scrolling mode='virtual' />
                                            <Column
                                                dataField='sectionName'
                                                caption='Section'
                                                width={140}
                                            />
                                            <Column
                                                dataField='fieldName'
                                                caption='Field'
                                                width={200}
                                            />
                                            <Column
                                                dataField='changeType'
                                                caption='Type'
                                                width={100}
                                            />
                                            <Column
                                                dataField='fromValue'
                                                caption='Old Value'
                                                cellRender={onCellRender}
                                            />
                                            <Column
                                                dataField='toValue'
                                                caption='New Value'
                                                cellRender={(e) => onCellRender(e, true)}
                                            />
                                        </DataGrid>
                                    </div>
                                </div>
                            </div>
                            <div
                                className='button-footer'
                                style={styles.buttonContainer}
                            >
                                <button
                                    style={styles.buttonMarginRight}
                                    type='button'
                                    className='button primary'
                                    onClick={_onClose}
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </DialogContent>
            </Dialog>
        </>
    );
};
